/* eslint-disable import/prefer-default-export */
export const hasMergedTimeSlot = (availabilityPlan) => {
  if (!Array.isArray(availabilityPlan?.entries)) {
    return false;
  }

  const groupedByDay = availabilityPlan.entries.reduce((acc, entry) => {
    const day = entry.dayOfWeek;
    if (!acc[day]) {
      acc[day] = [];
    }
    acc[day].push(entry);
    return acc;
  }, {});

  const hasMergeableTimeSlot = Object.values(groupedByDay).some((entries) => {
    const sortedEntries = entries.slice().sort((a, b) => a.startTime - b.startTime);
    for (let i = 1; i < sortedEntries.length; i++) {
      const prev = sortedEntries[i - 1];
      const current = sortedEntries[i];
      if (prev.endTime >= current.startTime) {
        return true;
      }
    }
    return false;
  });

  return hasMergeableTimeSlot;
};
